import { AxiosResponse } from "axios";
import RequestUtilitario, { MutationBasicaParam, QueryBasicaParam } from "../../../Utils/RequisicaoUtilitario";
import { Nota } from "../../../Models/Financeiro/Titulo/Nota";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Axios } from "../../Axios";
import dayjs from 'dayjs';
import { queryClient } from "../../../App";

export function useNotaListar({
    nota,
    dataCompetenciaInical,
    dataCompetenciaFinal,
    ativo,
    onFinish,
    ...rest
}:QueryBasicaParam<AxiosResponse<Nota[]>, Nota[], {
    nota?:Nota,
    dataCompetenciaInical?:dayjs.Dayjs,
    dataCompetenciaFinal?:dayjs.Dayjs,
    ativo?:boolean,
    onFinish:() => void
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...(nota ?? {}),
        dataCompetenciaInical: dataCompetenciaInical?.toDate().toJSON(),
        dataCompetenciaFinal: dataCompetenciaFinal?.toDate().toJSON(),
        ativo
    });

    return useQuery({
        ...rest,
        queryKey : ["Financeiro", "Titulo", "Nota", "Listar", queryString ],
        queryFn : () => Axios.get<Nota[]>(`financeiro/titulo/nota?${queryString}`).finally(() => onFinish?.()),
        select(data) {
            return data.data.map(m => {
                m.dataCriacao = new Date(m.dataCriacao as any);
                m.dataCompetencia = new Date(m.dataCompetencia as any);
                return m;
            })
        },
    });
}

export function useNotaEmitir({
    onSuccess,
    ...rest
}:MutationBasicaParam<Nota, AxiosResponse<void>>) {
    return useMutation({
        ...rest,
        mutationFn: (nota) => {
            return Axios.post<void>(`financeiro/titulo/${nota.codTitulo ?? 0}/nota`, nota);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Financeiro", "Titulo", "Nota"] });
            onSuccess?.(retorno, entrada, context);
        }
    });
}

export function useNotaManter({
    onSuccess,
    ...rest
}:MutationBasicaParam<Nota, AxiosResponse<void>>) {
    return useMutation({
        ...rest,
        mutationFn: (nota) => {
            return Axios.post<void>(`financeiro/titulo/${nota.codTitulo ?? 0}/nota/manter`, nota);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Financeiro", "Titulo", "Nota"] });
            onSuccess?.(retorno, entrada, context);
        }
    });
}

export function useNotaCancelar({
    onSuccess,
    ...rest
}:MutationBasicaParam<number, AxiosResponse<void>>) {
    return useMutation({
        ...rest,
        mutationFn: (codigo) => {
            return Axios.patch<void>(`financeiro/titulo/nota/${codigo}/cancelar`);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Financeiro", "Titulo", "Nota"] });
            onSuccess?.(retorno, entrada, context);
        }
    });
}